// extracted by mini-css-extract-plugin
export default {"button":"CompareButton_button__bQpPf","active":"CompareButton_active__eF25R"};